import React, { useEffect } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './AccessoriesProducts.css'; // Import your CSS file for styling
import ProductModal from './ProductModal';
import mp1_1 from './assets/men/mp1_1.JPG';
import mp1_2 from './assets/men/mp1_2.JPG';
import mp2_1 from './assets/men/mp2_1.JPG';
import mp2_2 from './assets/men/mp2_2.JPG';
import mp3_1 from './assets/men/mp3_1.jpg';
import mp3_2 from './assets/men/mp3_2.jpg';
import mp4_1 from './assets/men/mp4_1.JPG';
import mp4_2 from './assets/men/mp4_2.JPG';
import mp5_1 from './assets/men/mp5_1.JPG';
import mp5_2 from './assets/men/mp5_2.JPG';

import img2037_1 from './assets/men/0M1A2037.jpg';
import img2037_2 from './assets/men/0M1A2042.jpg';
import img2037_3 from './assets/men/0M1A2043.jpg';
import img2057 from './assets/men/0M1A2057.jpg';
import img2063 from './assets/men/0M1A2063.jpg';
import img2088_1 from './assets/men/0M1A2088.jpg';
import img2088_2 from './assets/men/0M1A2089.jpg';
import img2088_3 from './assets/men/0M1A2091.jpg';
import img7920_1 from './assets/men/0M1A7920.jpg';
import img7920_2 from './assets/men/0M1A7923.jpg';
import img7920_3 from './assets/men/0M1A7926.jpg';
import img7920_4 from './assets/men/0M1A7929.jpg';
import img7920_5 from './assets/men/0M1A7934.jpg';
import img2551_1 from './assets/men/2551-2584_(10).jpg';
import img2551_2 from './assets/men/2551-2584_(12).jpg';
import img2551_3 from './assets/men/2551-2584_(13).jpg';
import img2579_1 from './assets/men/704-2579_(3).jpg';
import img2579_2 from './assets/men/704-2579_(6).jpg';
import img2579_3 from './assets/men/704-2579_(8).jpg';
import img2581_1 from './assets/men/706-2581_(3).jpg';
import img2581_2 from './assets/men/706-2581_(7).jpg';
import img9240_1 from './assets/men/9240 (1).JPG';
import img9240_2 from './assets/men/9240 (2).JPG';
import img9240_3 from './assets/men/9240 (3).JPG';
import imgRN8356_1 from './assets/men/RN_8356.JPG';
import imgRN8356_2 from './assets/men/RN_8356 c.JPG';
import imgc2123 from './assets/men/c 2123.jpg';

const MenProducts = () => {
  const [selectedProduct, setSelectedProduct] = React.useState(null);
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const openProduct = (name, image) => {
    setSelectedProduct({ name, image, category: "MEN'S COLLECTION" });
    setIsModalOpen(true);
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const createCard = (images, title) => (
    <div 
      className="card" 
      onClick={(e) => {
        if (e.target.closest('.slick-arrow') || e.target.closest('.slick-dots')) {
          return;
        }
        openProduct(title, images);
      }}
    >
      {images.length > 1 ? (
        <Slider {...settings}>
          {images.map((img, index) => (
            <div key={index}><img src={img} alt={`${title} - ${index + 1}`} /></div>
          ))}
        </Slider>
      ) : (
        <div><img src={images[0]} alt={`${title} - 1`} /></div>
      )}
      <h3>{title}</h3>
    </div>
  );


  return (
    <div className="category-container">
      <h2>Men's Products</h2>
      <div className="card-container">
        {createCard([mp1_1, mp1_2], "1562")}
        {createCard([mp2_1, mp2_2], "1564")}
        {createCard([mp3_1, mp3_2], "ARI02532e")}
        {createCard([mp4_1, mp4_2], "8356")}
        {createCard([mp5_1, mp5_2], "1568")}

        {createCard([img2037_1, img2037_2, img2037_3], "Model 2037")}
        {createCard([img2057, img2063], "Model 2057")}
        {createCard([img2088_1, img2088_2, img2088_3], "Model 2088")}
        {createCard([img7920_1, img7920_2, img7920_3, img7920_4, img7920_5], "Model 7920")}
        {createCard([img2551_1, img2551_2, img2551_3], "2551-2584")}
        {createCard([img2579_1, img2579_2, img2579_3], "704-2579")}
        {createCard([img2581_1, img2581_2], "706-2581")}
        {createCard([img9240_1, img9240_2, img9240_3], "Model 9240")}
        {createCard([imgRN8356_1, imgRN8356_2], "RN 8356")}
        {createCard([imgc2123], "Model 2123")}
      </div>
      
      <ProductModal 
        product={selectedProduct} 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
      />
    </div>
  );
};

export default MenProducts;
